<div class="toggle-button" matRipple (click)="sidebarService.toggleSidebar()">
    <mat-icon class="menu-button">menu</mat-icon>
</div>